import React, { Component } from 'react';
import Link from '../components/link';

import Isvg from 'react-inlinesvg';
import Page from '../containers/page';

import { API_ENDPOINT } from '../constants';

import ErrorModal from '../components/errorModal';

/**
* NetId login component
* @author   Milan Stanojevic
*/
class NetId extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        let loginStorageKey = this.props[0].match.params.loginStorageKey;

        let groupAlias;
        if (typeof window !== 'undefined' && localStorage.getItem('groupAlias')) {
            groupAlias = localStorage.getItem('groupAlias');
        }


        fetch(API_ENDPOINT + '/users/netid/login', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({ loginStorageKey, groupAlias })
        }).then(res => res.json()).then((result) => {
            if (result.error) {
                this.setState({
                    error: result.error
                })
            } else {

                if (window.top) {
                    if (result.newUser) {
                        window.top.postMessage('loggedin_newuser', '*')

                    } else {
                        window.top.postMessage('loggedin_netid', '*')
                    }
                }

                localStorage.setItem('userLevel', 20);
                localStorage.setItem('logoutLandingPage', true);
                if (groupAlias)
                    localStorage.setItem('loginGroupAlias', groupAlias);

                localStorage.setItem('authToken', result.token);
                localStorage.setItem('profile', 'doctor');
                localStorage.setItem('userLevel', 20);
                localStorage.setItem('time', Math.floor(Date.now() / 1000))
                this.props.verifyUser();
                this.props[0].history.push('/')
            }
        });
    }

    render() {
        return (
            <div>
                {
                    this.state.error ?
                        <ErrorModal
                            lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => {
                                this.setState({ error: null }, () => {
                                    this.props[0].history.push('/login')
                                })
                            }}

                        >
                            {this.state.error.translate(this.props.lang)}
                        </ErrorModal>
                        :
                        null
                }


            </div>
        );
    }
}

export default NetId;
